import { Color } from 'three';

export const coloursToArray = (str) => {
  return str.split('/').pop().split('-').map(function (hex) {
    return new Color('#' + hex);
  });
};